import { Box, Flex, MantineSize, Text } from '@mantine/core';
import { TransactionState } from '@dealstack/shared/lib/generated';
import {
	formatPaymentStatusText,
	getPaymentStatusColor,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Payments/components/Table.utils.tsx';

interface Props {
	status: TransactionState;
	textSize?: MantineSize | number;
}

export const PaymentStatusIndicator = ({ status, textSize = 'md' }: Props) => (
	<Flex align="center" gap={6}>
		<Box
			w={6}
			h={6}
			style={{
				borderRadius: '50%',
				backgroundColor: getPaymentStatusColor(status),
			}}
		/>
		<Text fz={textSize} c={getPaymentStatusColor(status)}>
			{formatPaymentStatusText(status)}
		</Text>
	</Flex>
);
